import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { createAccountEmailInputValidator, createAccountInputValidator, stateValidator } from 'common/utils/createAccountValidators';
import { inputValidator } from '../account-admin-edit-form.service';
import { AppConstants } from 'common/app-constants';
import { UserDetails } from 'private/app/models/user.model';

@Injectable({ providedIn: 'root' })
export class UserAdminCreateService {
    public backToPreviousPageStep3: boolean = false;
    public userCreateForm = new UntypedFormGroup({
        firstName: new UntypedFormControl('', [Validators.required, createAccountInputValidator(41, true)]),
        lastName: new UntypedFormControl('', [Validators.required, createAccountInputValidator(41, true)]),
        userID: new UntypedFormControl(''),
        userTitle: new UntypedFormControl('', [createAccountInputValidator(41, false)]),
        employerName: new UntypedFormControl(''),

        companyName: new UntypedFormControl(''),
        companyId: new UntypedFormControl(''),
        hvacPin: new UntypedFormControl(''),

        userAddress1: new UntypedFormControl('', [createAccountInputValidator(61, true)]),
        userAddress2: new UntypedFormControl('', [createAccountInputValidator(61, false)]),
        userCity: new UntypedFormControl('', [createAccountInputValidator(41, true)]),

        userState: new UntypedFormControl('', [stateValidator]),
        userCountry: new UntypedFormControl('', [Validators.required]),
        userPostalCode: new UntypedFormControl('', [Validators.required]),

        userPhone: new UntypedFormControl('', [inputValidator(21, false), Validators.pattern(AppConstants.validPhoneRegex)]),
        userCellPhone: new UntypedFormControl('', [inputValidator(21, false), Validators.pattern(AppConstants.validPhoneRegex)]),
        userFax: new UntypedFormControl('', [inputValidator(21, false), Validators.pattern(AppConstants.validPhoneRegex)]),

        email: new UntypedFormControl('',
            [Validators.required, createAccountEmailInputValidator(242, true, AppConstants.validEmailRegex)]),
        contactOnly: new UntypedFormControl(''),

        lastLoginDate: new UntypedFormControl(''),
        registrationAction: new UntypedFormControl('', [Validators.required]),
        comments: new UntypedFormControl('', [createAccountInputValidator(500, false)])
    });

    private savedFormValues: Partial<UserDetails> | null = null;

    saveFormValues(): void {
        this.savedFormValues = this.userCreateForm.getRawValue();
    }

    restoreFormValues(): void {
        if (this.savedFormValues) {
            this.userCreateForm.setValue(this.savedFormValues);
        }
    }

    clearSavedFormValues(): void {
        this.savedFormValues = null;
    }

    public emptyUserInitialization() {
        this.userCreateForm.setValue({
            firstName: '',
            lastName: '',
            userID: '',
            userTitle: '',
            employerName: '',

            companyName: '',
            companyId: '',
            hvacPin: '',

            userAddress1: '',
            userAddress2: '',
            userCity: '',

            userState: '',
            userPostalCode: '',
            userCountry: '',

            userPhone: '',
            userCellPhone: '',
            userFax: '',

            email: '',
            contactOnly: '',

            registrationAction: 'Select',
            comments: '',
            lastLoginDate: ''
        });
    }

    public mapCreateUserDetails() {
        const formValue = this.userCreateForm.getRawValue();
        const createUserDetails: UserDetails = {
            userID: formValue.userID,
            companyId: formValue.companyId,
            employerName: formValue.employerName,
            firstName: formValue.firstName?.trim(),
            lastName: formValue.lastName?.trim(),
            userTitle: formValue.userTitle?.trim(),
            userAddress1: formValue.userAddress1,
            userAddress2: formValue.userAddress2,
            userCity: formValue.userCity,
            userCountry: (typeof formValue.userCountry === 'object') ? formValue.userCountry[0].value : formValue.userCountry.substring(formValue.userCountry.indexOf('-') + 1).trim(),
            userState: (typeof formValue.userState === 'object') ? formValue.userState[0].value : formValue.userState.substring(0, formValue.userState.indexOf('-')).trim(),
            userPostalCode: formValue.userPostalCode,
            userPhone: formValue.userPhone,
            userCellPhone: formValue.userCellPhone,
            userFax: formValue.userFax,
            email: formValue.email,
            contactOnly: formValue.contactOnly !== ''
        };

        return createUserDetails;
    }
}
